var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1486.8 1214.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a98e75;}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:#3a3d5d;}.cls-4,.cls-5{fill:#f4f4f4;}.cls-6{fill:#fff;}.cls-7{fill:url(#linear-gradient-17);}.cls-8{fill:#dcd0c8;}.cls-9{fill:#948c87;}.cls-10{fill:#8c8581;}.cls-11{fill:url(#linear-gradient-15);}.cls-12{fill:#997761;}.cls-13{fill:#90c1fc;}.cls-14{fill:url(#linear-gradient-18);}.cls-15{fill:#2e3048;}.cls-16{fill:#72acfb;}.cls-17{fill:#e6d8d1;}.cls-18{fill:#3e4148;}.cls-19{fill:url(#linear-gradient-14);}.cls-20{fill:url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_48);}.cls-20,.cls-21{mix-blend-mode:multiply;}.cls-22{fill:url(#linear-gradient-20);}.cls-23{fill:url(#linear-gradient-6);}.cls-24{isolation:isolate;}.cls-25{fill:#ebb35c;}.cls-26{fill:#f3e4dc;}.cls-27{fill:#5886c7;}.cls-28{fill:url(#linear-gradient-11);}.cls-29{fill:#dedede;}.cls-30{fill:#6d6865;}.cls-31{fill:#dba585;}.cls-32{fill:#b2a8a3;}.cls-33{fill:url(#linear-gradient-10);}.cls-34,.cls-5{mix-blend-mode:hard-light;}.cls-35{fill:#454971;}.cls-36{fill:url(#linear-gradient-16);}.cls-37{fill:#42466c;}.cls-38{fill:#363957;}.cls-39{fill:#dedfe6;}.cls-40{fill:#4372bd;}.cls-41{fill:url(#linear-gradient-5);}.cls-42{fill:#cfc3bc;}.cls-43{fill:#b9afaa;}.cls-44{fill:#8c8480;}.cls-45{fill:#cd7250;}.cls-46{fill:#4c507d;}.cls-47{fill:url(#linear-gradient-7);}.cls-48{fill:#558ad8;}.cls-49{fill:#414469;}.cls-50{fill:#bfd4fc;}.cls-51{fill:#385988;}.cls-52{fill:#5d5955;}.cls-53{fill:url(#linear-gradient-9);}.cls-54{fill:url(#linear-gradient-3);}.cls-55{fill:#df655a;}.cls-56{fill:url(#linear-gradient);}.cls-21{fill:url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_38);}.cls-57{fill:#4772b0;}.cls-58{fill:url(#linear-gradient-19);}.cls-59{fill:url(#linear-gradient-4);}.cls-60{fill:#c6bbb5;}.cls-61{fill:#4e85de;}.cls-62{fill:url(#linear-gradient-8);}.cls-63{fill:url(#linear-gradient-12);}.cls-64{fill:#6d76ba;}.cls-65{fill:url(#linear-gradient-13);}.cls-66{fill:#c8bcb6;}.cls-67{fill:#f4f6ff;}.cls-68{fill:#2a2b41;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_48",
    x1: -1377.42,
    y1: 1196.97,
    x2: -2487.94,
    y2: 1838.13,
    gradientTransform: "translate(-1184.11 2225.59) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6076fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81d3e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_38",
    x1: -1601.4,
    y1: 1329.73,
    x2: -2355.7,
    y2: 2084.03,
    gradientTransform: "translate(-1184.11 2225.59) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#81d3e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6076fa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -13028.44,
    y1: -2.76,
    x2: -12740.59,
    y2: -2.76,
    gradientTransform: "translate(-12536.81 -323.17) rotate(-176.92) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a612f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#769a42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -3805.41,
    y1: 3765.12,
    x2: -3805.41,
    y2: 3562.71,
    gradientTransform: "translate(841.89 -4837.52) rotate(-41.45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -13000.89,
    y1: -89.64,
    x2: -12864.64,
    y2: -89.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -2108.88,
    y1: 3119.27,
    x2: -2108.88,
    y2: 2920.52,
    gradientTransform: "translate(747.08 -3359.59) rotate(-29.45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 791.24,
    y1: 693.1,
    x2: 346.93,
    y2: 693.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eebe63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dc3b57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 791.25,
    y1: 717.39,
    x2: 346.93,
    y2: 717.39,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 791.24,
    y1: 741.68,
    x2: 346.93,
    y2: 741.68,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 125.21,
    y1: 782.49,
    x2: 286.63,
    y2: 782.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#81d3e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6076fa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 243.62,
    y1: 872.56,
    x2: 389.6,
    y2: 872.56,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 256.1,
    y1: 893.79,
    x2: 365.66,
    y2: 893.79,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 216.53,
    y1: 805.62,
    x2: 344.13,
    y2: 805.62,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 187.25,
    y1: 988.65,
    x2: 305,
    y2: 988.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e59148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1cc52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 187.25,
    y1: 988.65,
    x2: 305,
    y2: 988.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b37239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1cc52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 804.87,
    y1: 697.3,
    x2: 1001.9,
    y2: 697.3,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 927.42,
    y1: 535.61,
    x2: 993.28,
    y2: 535.61,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 927.42,
    y1: 570.53,
    x2: 987.88,
    y2: 570.53,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 927.42,
    y1: 553.07,
    x2: 979.73,
    y2: 553.07,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 804.87,
    y1: 532.99,
    x2: 908.63,
    y2: 532.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d3d8de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1047.17,
    y1: 425.94,
    x2: 1101.94,
    y2: 425.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#72acfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5286d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    y1: 407.89,
    x2: 1090.09,
    y2: 407.89,
    xlinkHref: "#linear-gradient-19"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Layer_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m243.25,849.88c130.7,24.66,193.01,120.88,269.64,185.66,90.22,76.26,199.89,34,293.62,20.55,168.49-24.18,225.76,153.32,411.16,129.79,177.43-22.51,246.68-244.77,136.37-372.04-110.31-127.27-106.69-165.7-81.33-255.73,25.36-90.03,70.02-258.56-107.59-273.78-152.65-13.08-240.88-51.22-308.08-117.51-67.19-66.29-314.67-248.82-430.11,28.45-55.16,132.5-88.42,179.11-212.36,213.1C90.63,442.37,4.01,535.93.13,641.87c-3.67,100.32,68.56,175.08,243.12,208.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m802.51,153.54c-105.52,76.99-222.91,87.08-346.75,62.52-123.84-24.56-227.42-29.03-308.48,87.09-81.06,116.11-50.8,334.65,168.87,388.53,209.4,51.36,244.34,219.79,281.45,339.4,45.03,145.14,180.13,205.43,319.73,176.4,139.6-29.03,177.88-131.74,231.92-290.28,54.04-158.54,117.76-178.12,211.65-225.53,114.99-58.06,212.61-233.53,2.25-332.71-274.7-129.51-253.87-429.28-560.66-205.43Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m447.37,382.52c18.66,40.72,29.14,79.25,15.4,96.43-.81,1.02-1.7,1.95-2.66,2.8-10.58,9.32-31.4,9.53-66.54-4.35-93.52-36.94-97.96-100.7-116.88-162.96-18.65-61.48-83.78-51.09-85.44-50.81,151.77-52.87,224.45,49.86,256.11,118.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m462.77,478.95c-.81,1.02-1.7,1.95-2.66,2.8-17.57-10.58-51.21-33.02-67.06-58.21-7.48-11.89-13.77-25.25-20.44-39.39-12.58-26.75-25.62-54.4-48.37-75.62l2.54-2.73c23.27,21.72,36.44,49.7,49.19,76.77,6.61,14.04,12.85,27.3,20.23,38.99,15.46,24.57,49.45,47.1,66.58,57.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m431.12,399.15c-1.1,2.71-1.81,4.24-1.89,4.41-.29-1.49-.57-2.98-.85-4.41-12.48-63.92-29.16-70.6-79.18-126.52-51.16-57.19-21.74-110.48-21.74-110.48,171.39,49.52,115.31,208.42,103.66,237Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m431.12,399.15c-1.1,2.71-1.81,4.24-1.89,4.41-.29-1.49-.57-2.98-.85-4.41,5.55-55.26-27.78-120.11-38.26-131.74-10.84-12.05-17.52-28.62-20.04-34.87-.42-1.03-.82-2.02-.95-2.25l2.42-1.37c.21.38.49,1.06,1.11,2.58,2.46,6.12,9.02,22.36,19.54,34.03,13.28,14.76,44.04,79.92,38.94,133.62Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m452.57,68.02h731.04c27.33,0,49.51,22.19,49.51,49.51v209.16c0,27.33-22.19,49.52-49.52,49.52H452.57c-27.33,0-49.51-22.19-49.51-49.51V117.53c0-27.33,22.19-49.51,49.51-49.51Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 446.52,
    y: 736.48,
    width: 311.22,
    height: 10.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 446.52,
    y: 687.89,
    width: 231.13,
    height: 10.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 446.52,
    y: 712.18,
    width: 249.74,
    height: 10.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 446.52,
    y: 736.48,
    width: 162.04,
    height: 10.41
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m292.83,392.91h448.16c20.28,0,36.74,16.46,36.74,36.74v404.18c0,20.27-16.46,36.73-36.73,36.73h-448.15c-20.28,0-36.74-16.46-36.74-36.74v-404.18c0-20.27,16.46-36.73,36.73-36.73Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m449.42,537.59c10.57-29.55,1.03-61.41-21.54-80.61-5.38-4.58-11.5-8.44-18.27-11.38-1.49-.65-3.02-1.25-4.57-1.8-15.62-5.59-31.88-5.56-46.58-.96-21.21,6.64-39.16,22.8-47.22,45.34-2.66,7.44-4.04,15.02-4.27,22.52-.93,30.94,17.94,60.29,48.65,71.28,38.16,13.64,80.15-6.22,93.8-44.38Zm-87.62,27.09c-23.03-8.23-37.18-30.25-36.48-53.44.17-5.62,1.21-11.3,3.21-16.88,6.04-16.9,19.5-29.01,35.4-33.99,11.02-3.44,23.21-3.47,34.92.72,1.16.42,2.31.87,3.43,1.36,5.08,2.2,9.66,5.1,13.7,8.53,16.92,14.39,24.07,38.28,16.15,60.44-10.23,28.61-41.72,43.5-70.33,33.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m363.93,460.37l-5.48-17.53c-21.21,6.64-39.16,22.8-47.22,45.34-2.66,7.44-4.04,15.02-4.27,22.52l18.36.55c.17-5.62,1.21-11.3,3.21-16.88,6.04-16.9,19.5-29.01,35.4-33.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m402.28,462.44l7.33-16.84c-1.49-.65-3.02-1.25-4.57-1.8-15.62-5.59-31.88-5.56-46.58-.96l5.48,17.53c11.02-3.44,23.21-3.47,34.92.72,1.16.42,2.31.87,3.43,1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m427.88,456.98c-5.38-4.58-11.5-8.44-18.27-11.38l-7.33,16.84c5.08,2.2,9.66,5.1,13.7,8.53l11.9-13.99Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 657.5,
    y: 686.55,
    width: 25.46,
    height: 87.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 619.64,
    y: 711.02,
    width: 25.46,
    height: 62.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 694.22,
    y: 646.13,
    width: 25.46,
    height: 127.64
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "715.58 582.36 715.13 579.61 647.93 590.61 626.14 637.04 553.69 641.96 530.22 676.58 474.83 675.21 474.76 678 531.67 679.41 555.23 644.65 627.97 639.72 649.83 593.13 715.58 582.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m633.45,466.13h72.42c4.57,0,8.28-3.71,8.28-8.28h0c0-4.58-3.71-8.28-8.28-8.28h-72.42c-4.57,0-8.28,3.7-8.28,8.28h0c0,4.57,3.7,8.28,8.28,8.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m633.45,495.02h72.42c4.57,0,8.28-3.71,8.28-8.28h0c0-4.57-3.71-8.28-8.28-8.28h-72.42c-4.57,0-8.28,3.71-8.28,8.28h0c0,4.57,3.7,8.28,8.28,8.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m633.45,523.9h72.42c4.57,0,8.28-3.71,8.28-8.28h0c0-4.57-3.71-8.28-8.28-8.28h-72.42c-4.57,0-8.28,3.71-8.28,8.28h0c0,4.57,3.7,8.28,8.28,8.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "502.37 480.45 460.95 480.45 460.95 478.86 501.71 478.86 523.52 457.05 550.23 457.05 550.23 458.64 524.18 458.64 502.37 480.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "541.62 552.8 488.32 552.8 471.05 535.53 472.17 534.4 488.98 551.21 541.62 551.21 541.62 552.8"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 527.46,
    y: 467.58,
    width: 55.25,
    height: 6.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 510.61,
    y: 536.7,
    width: 44.48,
    height: 6.78
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m139.31,569.19c13.92-6.66,27.77,37.65,27.77,37.65,23.66,31.27,56.72-10.33,53.48,36.41-5.66,81.77,94.12,25.71,48.09,111.09-46.03,85.37,40.65,48.27,12.04,117.11-28.61,68.84,8.47,150.94-34.57,117.2,0,0-37.9-83.11-76.98-108.82-39.09-25.72,23.41-56.23,11.19-91.16-17.76-50.73-60.56-48.74-29.7-103.25,30.86-54.51-58.63-93.6-11.31-116.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m259.75,957.37c-18.66-13.12-40.5-104.56-41.79-159.03-.67-27.9-8.92-39.52-16.19-49.77-6.95-9.8-12.96-18.27-9.46-37.71,6.69-37.15-10.89-53.19-11.07-53.34l2.03-2.32c.78.68,19.09,17.23,12.08,56.2-3.27,18.17,2.12,25.76,8.94,35.38,7.16,10.09,16.07,22.65,16.76,51.49,1.4,58.45,23.72,144.78,40.49,156.57l-1.77,2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m266.73,964.14c-2.41,0-5.02-.28-7.89-.86-7.19-1.46-11.91-5.24-14.02-11.28-5.03-14.38,6.63-37.75,16.09-49.01.16-.19,15.99-19.54,14.3-46.36-.28-4.49-.75-8.66-1.16-12.32-1.19-10.61-2.05-18.28,2.51-23.4,4.02-4.51,11.77-6.47,25.93-6.54,24.83-.11,34.65-10.39,42.54-18.65,3.35-3.51,6.51-6.82,10.36-8.92h0c12.38-6.76,25.48-7.75,31.17-2.36,2.7,2.56,4.98,7.57.5,16.91-4.09,8.55-9.39,13.96-13.65,18.3-5.73,5.85-9.52,9.71-7.55,17.41.46,1.81,1,3.63,1.53,5.47,3.83,13.09,8.17,27.93-14.24,38-4.75,2.14-9.08,3.84-12.91,5.34-15.64,6.14-25.08,9.85-35.74,32.34-2.06,4.36-3.89,8.48-5.65,12.47-8.4,19.05-14.76,33.45-32.13,33.45Zm90.13-174.64c-3.42,1.87-6.29,4.87-9.61,8.35-8.29,8.68-18.61,19.49-44.75,19.61-13.02.06-20.31,1.76-23.64,5.5-3.64,4.09-2.85,11.19-1.75,21,.42,3.71.88,7.91,1.17,12.48,1.77,28.09-14.33,47.71-15.01,48.53-9.36,11.15-19.97,33.34-15.54,46.01,1.73,4.93,5.66,8.05,11.71,9.27,21.11,4.27,26.93-8.94,36.58-30.82,1.77-4.01,3.6-8.16,5.68-12.55,11.18-23.6,21.61-27.7,37.41-33.9,3.79-1.49,8.09-3.17,12.77-5.28,19.96-8.97,16.36-21.29,12.55-34.32-.55-1.86-1.09-3.72-1.56-5.56-2.4-9.39,2.33-14.22,8.33-20.34,4.31-4.4,9.2-9.39,13.07-17.47,2.03-4.24,3.7-9.99.15-13.35-4.66-4.42-16.51-3.2-27.56,2.83h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m259.18,981.96l-3.08-.16c.15-2.9,4.04-71.13,31.44-91.11,30.06-21.91,39.54-45.46,44.05-61.26,5.32-18.62,32.39-23.6,33.54-23.8l.54,3.04c-.26.05-26.32,4.85-31.11,21.61-4.64,16.24-14.37,40.44-45.2,62.91-26.23,19.12-30.14,88.09-30.17,88.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m321.83,638.05c-19.47-6.67-15.43,30.86-23.66,58.64-8.23,27.77-91.55,12.11-56.57,81.65,34.97,69.55-44.23,23.26-20.57,83.95,23.66,60.68,2.06,125.59,27.77,109.08,25.71-16.51,14.45-92.93,41.19-102.01,26.74-9.08,31.11-19.67,4.62-44.36-26.48-24.68,69.39-49.19,45.73-99.04-23.66-49.85,3.98-80.19-18.52-87.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m260.73,968.45c-2.45-10.38-23.36-101.81-3.85-112.87,17.2-9.74,16.78-47.62,14.09-83.4-2.37-31.67,38.3-46.47,40.03-47.08l1.03,2.91c-.4.14-40.18,14.63-37.98,43.95,2.76,36.74,3.05,75.72-15.65,86.32-14.82,8.4-1.17,81.87,5.33,109.47l-3,.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "305 935.9 277.19 1041.39 215.05 1041.39 187.25 935.9 305 935.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m305,935.9s-61.21,11.49-61.21,105.48h-28.73l-27.8-105.48h117.74Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "473.1 26.07 473.1 35.01 385.9 35.01 385.9 122.22 376.95 122.22 376.95 26.07 473.1 26.07"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 1191.43,
    width: 70.98,
    height: 4.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 1191.43,
    y: 9.38,
    width: 70.98,
    height: 20.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 1142.75,
    y: 17.33,
    width: 41.88,
    height: 3.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 1142.75,
    y: 21.83,
    width: 41.88,
    height: 8.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 1260.85,
    width: 3.12,
    height: 58.61
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 391.29,
    y: 798.87,
    width: 87.6,
    height: 5.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 403.03,
    y: 817.6,
    width: 7.67,
    height: 236.48,
    transform: "translate(813.73 1871.69) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 465.17,
    y: 797.39,
    width: 60.89,
    height: 7.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 484.09,
    y: 734.03,
    width: 23.06,
    height: 70.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 359.86,
    y: 804.16,
    width: 337.36,
    height: 13.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m295.12,722.77s-3.69,51.74,6.42,57.94c6.33,3.88,31.59,16.96,30.84,19.42-.75,2.45-14.26,21.83-14.26,21.83,0,0-48.51-31.95-50.07-42.01-1.53-9.83,2.39-75.76,9.06-78.8,4.99-2.27,7.63-.39,13.92,4.28,8.83,6.56,4.09,17.34,4.09,17.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m354.79,1021.79s-1.51,10.47-1.7,12.04c-.19,1.57-16.78-.93-16.78-.93l-1.34-12.47s17.75-.12,19.82,1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m353.27,1032.5s5.26,6.31,10.34,9.06c5.08,2.75,13.07,3.84,16.08,6.69,2.17,2.05,7.9,10.9-13.21,10.72-21.11-.18-31.3,1.25-33.56-2.14-2.26-3.4,3.27-25.03,3.27-25.03,0,0,5,1.8,17.07.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m461.09,1021.89s-1.51,10.47-1.7,12.04c-.19,1.57-16.78-.93-16.78-.93l-1.34-12.47s17.75-.13,19.82,1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m459.57,1032.6s5.26,6.31,10.34,9.05c5.08,2.75,23.79,5.01,26.8,7.86,2.17,2.05,5.78,10.33-23.93,9.55-21.11-.55-31.3,1.25-33.56-2.14-2.26-3.39,3.27-25.03,3.27-25.03,0,0,4.71,1.92,17.07.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m301.28,840.94s60.32,10.2,73.94,12.34c13.62,2.14,87.49,20.52,96.73,26.12,7.35,4.46-3.86,111.54-6.48,152.39h-29.09l-2.11-122.54c-34.91.87-59.83-8.17-85.25-4.3-25.42,3.86-46.62,9.35-62.78-12.32,0,0-.6-46.94,15.04-51.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m360.74,1031.9l-28.35-1.76-2.77-120.89c-15.03.37-20.18-.58-32.34-2.05l-22.9-53.21c20.06,4.01,84.34,20.23,92.91,25.42,7.36,4.46-3.94,111.63-6.56,152.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m329.05,614.85s22.11-6.11,30.55,11.06c8.44,17.16,4.61,49.7-6.53,52.76-11.15,3.06-27.17-.46-31.8-11.15-4.62-10.68-8.31-25.86-7.21-35.69,1.11-9.83,9.12-14.63,14.99-16.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m347.29,675.24s-.24,13.05,1.2,15.84c1.44,2.78-30.79,2.08-30.79,2.08,0,0,5.08-15.68,2.2-29.03-2.85-13.22,27.39,11.11,27.39,11.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m318.15,659.19s1.73,3.51,10.07,2.94c8.34-.56,19.35-10.63,22.89-11.53,3.54-.9,3.75-2.91,3.75-2.91l1.87,3.33,3.63.56s-2.46-10.09,2.91-13.64c5.37-3.55-2.42-32.16-29.62-25.26,0,0-20.76,3.8-21.04,15.39-.28,11.59,1.52,24.98,5.54,31.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m350.18,690.75s-.09-5.32-2.5-5.83c-2.41-.5-25.33-3.66-28.29-2.5l-1.27,7.02s5.7,3.51,32.06,1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m356.81,645.31c-.62-4.36-5.57-9.37-8.41-2.58-2.84,6.79,1.92,16.67,5.1,16.14,3.18-.53,4.15-7.65,3.31-13.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m446.2,753.57s-.02,0-.04,0c.17.07.19.08.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m322.6,617.96s-26.96-1.27-4.71,40.81l4.71-40.81Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "262.53 1046.23 264.54 1051.88 349.28 1025.62 345.22 1014.2 262.53 1046.23"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 342.55,
    y: 929.47,
    width: 9.63,
    height: 92.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 318.96,
    y: 924.58,
    width: 56.81,
    height: 5.43
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "432.94 1046.23 430.94 1051.88 346.2 1025.62 349.93 1013.48 432.94 1046.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "373.25 1051.27 373.25 1057.83 346.2 1025.62 349.93 1013.48 373.25 1051.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m440.86,1054.08c0,4.37-3.54,7.92-7.92,7.92s-7.92-3.55-7.92-7.92,3.55-7.92,7.92-7.92,7.92,3.54,7.92,7.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m373.92,1054.08c0,4.37-3.55,7.92-7.92,7.92s-7.92-3.55-7.92-7.92,3.54-7.92,7.92-7.92,7.92,3.54,7.92,7.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m270.45,1054.08c0,4.37-3.54,7.92-7.92,7.92s-7.92-3.55-7.92-7.92,3.54-7.92,7.92-7.92,7.92,3.54,7.92,7.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m404.75,924.58h-114.02c-5.68,0-10.28-4.6-10.28-10.28h0c0-5.68,4.6-10.28,10.28-10.28h114.02c5.68,0,10.28,4.6,10.28,10.28h0c0,5.68-4.6,10.28-10.28,10.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 646.38,
    y: 817.6,
    width: 7.67,
    height: 236.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m407.78,627.32h175.68c6.46,0,11.71,5.25,11.71,11.71v117.04c0,6.46-5.24,11.71-11.71,11.71h-175.69c-6.46,0-11.71-5.25-11.71-11.71v-117.04c0-6.46,5.25-11.71,11.71-11.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 403.87,
    y: 634.91,
    width: 183.5,
    height: 110.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m579.21,756.22c0,3.15-3.31,5.7-7.39,5.7s-7.4-2.55-7.4-5.7,3.31-5.71,7.4-5.71,7.39,2.55,7.39,5.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m536.84,804.34v-2.5s-3.51-15.55-28.37-15.55-24.35,18.05-24.35,18.05h52.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m483.81,788.6s5.4-.42,7.38-1.62c1.98-1.2,13.81-9.15,16.59-7.88,2.78,1.28,21.28,6.95,20.64,9.65-.64,2.71-2.35,2.44-3.66,1.97-1.3-.48-14.74-3.3-15.92-2.82,0,0,13.2,4.82,13.25,8.33.05,3.52-2.76,4.37-4.01,5.7-1.25,1.33-2.75,4.63-6.15,4.88-3.4.26-20-5.52-23.41-5.78-3.41-.27-9.74.21-10.17-.35-.43-.55,5.47-12.07,5.47-12.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m385.51,698.11c-17.22-3.03-35.34-7.37-35.34-7.37l-32.06-1.31s-29.43,6.48-41.01,11.71c-1.1.5-1.11,26.25-4.12,33.01l9.61,20.27s5.55,40.15,6.7,58.01c.53,8.2-1.49,79.23-1.49,79.23,0,0,2.88,1.42,24.76,3.83,21.88,2.42,76.56-.87,76.9-3.45.35-2.59-10.59-96.24-11.07-101.09-.74-7.44,2.15-41.84,2.15-41.84,4.12,5.54,14.63,30.55,25.59,42.45,6.44,7,38.36,11.29,44.37,11.49,13.09.44,36.98,3.05,37.68,1.77.56-.77,2.08-21.21.58-21.7-1.31-.44-45.66-2.99-57.03-9.02-4.16-2.21-16.58-29.3-16.58-29.3,0,0-20.13-42.42-29.63-46.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m271.55,761.07h47.73c12.44,0,22.54,10.1,22.54,22.54v83.47c0,12.43-10.1,22.53-22.53,22.53h-47.75c-12.44,0-22.53-10.1-22.53-22.53v-83.47c0-12.44,10.1-22.54,22.54-22.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m325.38,919.46c-13.68,0-24.78-4.59-32.99-13.66-18.55-20.48-15.22-56.49-15.07-58.01.28-2.84,2.81-4.92,5.65-4.63,2.84.29,4.91,2.81,4.63,5.65-.04.41-3,33.05,12.46,50.08,6.25,6.89,14.53,10.24,25.32,10.24,2.85,0,5.16,2.31,5.16,5.16s-2.31,5.17-5.16,5.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m418.56,643.74h50.39c.93,0,1.68.75,1.68,1.68v2.5c0,.93-.75,1.68-1.68,1.68h-50.4c-.93,0-1.68-.75-1.68-1.68v-2.5c0-.93.75-1.68,1.68-1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m418.55,656.3h50.4c.93,0,1.68.75,1.68,1.68v2.5c0,.93-.75,1.68-1.68,1.68h-50.4c-.93,0-1.68-.75-1.68-1.68v-2.51c0-.92.75-1.67,1.67-1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m422.52,670.71h42.47c3.12,0,5.65,2.53,5.65,5.65v54.94c0,3.11-2.53,5.64-5.64,5.64h-42.47c-3.12,0-5.65-2.53-5.65-5.65v-54.94c0-3.11,2.53-5.64,5.64-5.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m490.41,643.74h77.86c4.93,0,8.93,4,8.93,8.93v75.33c0,4.93-4,8.93-8.93,8.93h-77.86c-4.93,0-8.93-4-8.93-8.93v-75.33c0-4.93,4-8.93,8.93-8.93Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m650.81,193.21c-16.14-45.13-59.27-72.85-104.73-71.48-11,.34-22.15,2.37-33.08,6.28-33.11,11.84-56.85,38.22-66.61,69.38-6.76,21.59-6.8,45.48,1.41,68.43.82,2.28,1.7,4.53,2.65,6.72,4.32,9.94,9.98,18.93,16.71,26.84,28.21,33.17,75.02,47.18,118.45,31.65,56.06-20.05,85.25-81.76,65.21-137.82Zm-74.29,112.41c-32.56,11.65-67.65,1.14-88.81-23.72-5.04-5.93-9.29-12.67-12.52-20.13-.72-1.64-1.38-3.33-1.99-5.04-6.15-17.21-6.12-35.12-1.05-51.31,7.31-23.36,25.11-43.14,49.94-52.01,8.2-2.94,16.55-4.46,24.8-4.71,34.08-1.03,66.42,19.76,78.52,53.59,15.03,42.03-6.86,88.29-48.89,103.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m472.15,205.42l-25.76-8.04c9.76-31.16,33.5-57.54,66.61-69.38,10.93-3.91,22.08-5.94,33.08-6.28l.81,26.97c-8.25.26-16.6,1.78-24.8,4.71-24.83,8.87-42.62,28.65-49.94,52.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "m475.19,261.77l-24.74,10.77c-.95-2.19-1.83-4.44-2.65-6.72-8.21-22.95-8.17-46.84-1.41-68.43l25.76,8.04c-5.07,16.19-5.1,34.1,1.05,51.31.61,1.71,1.28,3.4,1.99,5.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m467.16,299.37c-6.73-7.91-12.39-16.9-16.71-26.84l24.74-10.77c3.24,7.45,7.49,14.2,12.52,20.13l-20.55,17.48Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 693.44,
    y: 199.8,
    width: 19.09,
    height: 135.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 740.84,
    y: 227.42,
    width: 19.09,
    height: 108.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 788.24,
    y: 207.1,
    width: 19.09,
    height: 128.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 835.64,
    y: 247.23,
    width: 19.09,
    height: 88.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 883.04,
    y: 211.27,
    width: 19.09,
    height: 124.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 930.44,
    y: 192.5,
    width: 19.09,
    height: 143.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 977.84,
    y: 184.67,
    width: 19.09,
    height: 151.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 693.44,
    y: 250.46,
    width: 19.09,
    height: 85.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 740.84,
    y: 267.8,
    width: 19.09,
    height: 67.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 788.24,
    y: 255.04,
    width: 19.09,
    height: 80.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 835.64,
    y: 280.22,
    width: 19.09,
    height: 55.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 883.04,
    y: 257.66,
    width: 19.09,
    height: 78.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 930.44,
    y: 245.88,
    width: 19.09,
    height: 89.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 977.84,
    y: 240.98,
    width: 19.09,
    height: 94.79
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 1030.14,
    y: 199.8,
    width: 19.09,
    height: 135.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 1077.54,
    y: 227.42,
    width: 19.09,
    height: 108.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 1124.94,
    y: 207.1,
    width: 19.09,
    height: 128.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 1172.34,
    y: 247.23,
    width: 19.09,
    height: 88.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 1030.14,
    y: 250.46,
    width: 19.09,
    height: 85.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 1077.54,
    y: 267.8,
    width: 19.09,
    height: 67.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 1124.94,
    y: 255.04,
    width: 19.09,
    height: 80.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 1172.34,
    y: 280.22,
    width: 19.09,
    height: 55.54
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m690.11,113.22h494.05c4.01,0,7.27,3.26,7.27,7.27v4.89c0,4.01-3.26,7.27-7.27,7.27h-494.05c-4.01,0-7.26-3.25-7.26-7.26v-4.89c0-4.01,3.26-7.27,7.27-7.27Z",
    transform: "translate(1874.28 245.86) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m690.11,147.1h494.05c4.01,0,7.27,3.26,7.27,7.27v4.89c0,4.01-3.26,7.27-7.27,7.27h-494.05c-4.01,0-7.26-3.25-7.26-7.26v-4.89c0-4.01,3.26-7.27,7.27-7.27Z",
    transform: "translate(1874.28 313.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m811.36,393.26h185.34c12.76,0,23.13,10.36,23.13,23.13v346.77c0,12.76-10.36,23.13-23.13,23.13h-185.34c-12.76,0-23.13-10.36-23.13-23.13v-346.78c0-12.76,10.36-23.12,23.12-23.12Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 804.37,
    y: 627.69,
    width: 1.01,
    height: 129.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 853.62,
    y: 627.69,
    width: 1.01,
    height: 129.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 902.88,
    y: 627.69,
    width: 1.01,
    height: 129.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 952.14,
    y: 627.69,
    width: 1.01,
    height: 129.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 1001.39,
    y: 627.69,
    width: 1.01,
    height: 129.92
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m804.87,704.94s20.07,16.9,39.47-3.12c19.4-20.02,41.77-26.71,61.55-9.85,19.78,16.86,27.48-6.28,47.25-25.24,19.78-18.96,19.46-29.75,48.75-29.75v120.63h-197.02v-52.68Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 854.13,
    y: 616.87,
    width: 12.24,
    height: 4.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 804.37,
    y: 616.87,
    width: 16.66,
    height: 4.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 903.39,
    y: 616.87,
    width: 15.08,
    height: 4.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 952.14,
    y: 616.87,
    width: 15.08,
    height: 4.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 986.81,
    y: 616.87,
    width: 15.08,
    height: 4.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 927.42,
    y: 531.44,
    width: 65.86,
    height: 8.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 927.42,
    y: 566.36,
    width: 60.46,
    height: 8.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 927.42,
    y: 548.9,
    width: 52.31,
    height: 8.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m868.37,519.55c0,6.36-5.15,11.52-11.52,11.52s-11.52-5.15-11.52-11.52,5.16-11.51,11.52-11.51,11.52,5.15,11.52,11.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m877.63,557.09v21.9c-6.36,2.89-13.43,4.5-20.87,4.5s-14.52-1.61-20.88-4.5v-21.9c0-11.53,9.34-20.87,20.88-20.87s20.87,9.35,20.87,20.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m856.76,584.87c-7.48,0-14.7-1.56-21.44-4.63-18.49-8.4-30.44-26.95-30.44-47.26,0-28.6,23.28-51.88,51.88-51.88s51.88,23.27,51.88,51.88c0,20.31-11.95,38.85-30.44,47.26-6.74,3.07-13.96,4.63-21.44,4.63Zm0-101.02c-27.1,0-49.15,22.04-49.15,49.14,0,19.23,11.32,36.8,28.84,44.77,6.38,2.91,13.22,4.38,20.31,4.38s13.92-1.47,20.3-4.38c17.52-7.96,28.83-25.53,28.83-44.77,0-27.1-22.05-49.14-49.14-49.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m959.68,511.07c-17.29,0-31.34-14.06-31.34-31.34s14.06-31.34,31.34-31.34,31.34,14.06,31.34,31.34-14.06,31.34-31.34,31.34Zm0-56.41c-13.82,0-25.07,11.25-25.07,25.07s11.24,25.07,25.07,25.07,25.06-11.25,25.06-25.07-11.24-25.07-25.06-25.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 854.41,
    y: 417.26,
    width: 47.23,
    height: 7.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 861.37,
    y: 436.66,
    width: 40.26,
    height: 7.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 836.89,
    y: 456.07,
    width: 64.74,
    height: 7.53
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1040.32,392.44h145.27c3.22,0,5.83,2.61,5.83,5.83v100.22c0,3.22-2.61,5.83-5.83,5.83h-145.28c-3.22,0-5.83-2.61-5.83-5.83v-100.23c0-3.22,2.61-5.83,5.83-5.83Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "m1050.43,421.95h48.25c1.8,0,3.26,1.46,3.26,3.26v1.46c0,1.8-1.46,3.26-3.26,3.26h-48.25c-1.8,0-3.26-1.46-3.26-3.26v-1.46c0-1.8,1.46-3.26,3.26-3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m1050.05,403.9h37.15c1.59,0,2.89,1.29,2.89,2.89v2.2c0,1.59-1.29,2.89-2.89,2.89h-37.15c-1.59,0-2.88-1.29-2.88-2.88v-2.21c0-1.59,1.29-2.88,2.88-2.88Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "1047.17 488.88 1078.91 457.14 1088.39 466.62 1123.22 431.79 1138.68 447.25 1179.12 406.81 1179.12 488.88 1047.17 488.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "1178.76 488.88 1178.76 425.94 1137.05 467.65 1122.11 452.71 1097.2 477.62 1078.32 470.11 1047.17 488.88 1178.76 488.88"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1084.02,1036.7s-11.7,16.43-10.09,19.04c1.6,2.6,13.9,2.98,21.39,0,7.49-2.98,7.67-22.23,11.06-30.51,1.42-3.46-1.62-13.69-5.89-14.43-4.27-.74-8.91,1.43-8.91,1.43,0,0,4.42,11.66-7.56,24.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m1091.51,1012.1s-2.46,7-3.36,13.68c-.75,5.54-8.33,17.31-7.98,18.8.36,1.49,9.98,2.84,13.9-1,3.92-3.83,6.45-14.99,7.31-21.67.81-6.22,1.82-9.29,1.82-9.29,0,0-7.96-4.61-11.7-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1185.84,1036.98s-11.28,16.16-9.67,18.76c1.61,2.6,13.91,2.98,21.4,0,7.49-2.98,7.66-22.23,11.05-30.51,1.42-3.46-1.62-13.69-5.88-14.43-4.27-.74-9.27,1.6-9.27,1.6,0,0,4.37,11.77-7.62,24.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m1193.46,1012.4s-.89,7.62-2.32,13.02c-1.43,5.39-9.09,17.67-8.74,19.16.36,1.49,9.98,2.84,13.9-1,3.92-3.83,6.95-14.95,7.31-21.67.36-6.72-.89-11.11-.89-11.11,0,0-5.53-2.5-9.27,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m1137.11,744.87s-10.04,48.73-12.34,61c-2.31,12.27-8.76,71.68-9.45,81.79-.69,10.1-10.47,48.17-10.01,51.78.46,3.61-14.51,76.09-14.51,76.09,0,0,5.11,4.29,10.5.39,2.77-2.01,32.83-67.86,32.83-85.9,0-24.94,17.67-57.49,19.95-63.07,21.18-51.83,17.01-67.68,19.78-71.04,2.77-3.37,3,2.08,4.62,9.54,1.61,7.46,5.07,71.93,7.14,80.1,2.07,8.18.47,35.84,1.62,49.79,1.15,13.95,6.21,77.07,6.21,77.07,0,0,3.92,6.4,9.42.16,1.18-1.34,9.49-70.3,9.72-86.9.23-16.59.48-39.49.92-46.66,4.27-68.79,14.77-78.61-1.77-127.29-30.96-91.15-74.64-6.84-74.64-6.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m1204.52,731.26s28.6,41.76,16.28,130.6c0,0-67.82,9.63-104.16-11.13,0,0,15.02-91.59,20.47-105.85,5.45-14.25,67.41-13.61,67.41-13.61Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1106.69 1023.78 1106.69 1040.99 1104.55 1040.99 1104.55 1027.7 1106.69 1023.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1208.93 1023.78 1208.93 1040.99 1206.79 1040.99 1206.79 1027.7 1208.93 1023.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m1170.62,546.07s-19.15,19.29-12.63,44.13c6.52,24.84,17,24.98,28.55,14.3,11.55-10.69,18.35-21.93,19.88-34.42,1.52-12.49-18.32-41.22-35.8-24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m1166.87,628.92s2.84-6.5,4.83-13.81c.35-1.29.67-2.61.95-3.92.98-4.6,1.38-9.14.32-12.25-3.05-9.02,19.15-2.78,19.15-2.78,0,0-4.3,23.87,0,31.91,4.3,8.05-25.26.83-25.26.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m1223.15,640.29c-3.5-6.98-6.11-9.22-12.86-11.36-3.78-1.19-20.67-5.59-20.67-5.59l-20.28-.74s-13.95,2.32-24.77,6.07c-10.83,3.75-25.01,24.25-25.01,24.25,0,0,19.56,45.94,23.31,59.12,3.74,13.19,1.25,33.58,1.25,33.58,23.45,12.77,61.06-1.25,61.06-1.25-2.85-10.3-2.97-22.33-1.47-30.86.18-1.01.37-1.96.59-2.87.2-.82.48-1.99.8-3.31.01-.06.03-.11.04-.17,14.92,1.53,28.91,2.14,29.27-.84,1.64-13.48-6.46-56.45-11.27-66.04Zm-10.34,52.37c-.6-.09-1.88-.09-3.23-.22,1.66-4.62,3.51-8.71,3.51-8.71,1.06,2.95,5.08,9.73-.27,8.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m1176.87,559.95s9.16,16.65,14.85,22.62c5.69,5.97,5.02,10.71,5.02,10.71,0,0,22.18-27.36,6.36-43.87-15.82-16.51-36.22-9.86-42.19,4.58-5.97,14.43-3.78,32.06-3.78,32.06,0,0,.18-16.94,19.74-26.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m1182.91,542.51s-2.22-12.19,16.9-17.04c19.12-4.85,27.71,17.18,25.35,30.62-2.36,13.44-18.7,47.51-9.84,51.95,8.87,4.43,12.33-5.13,12.33-5.13,0,0-2.77,16.76-15.1,12.88-12.33-3.88-10.67-31.12-8.81-41.98,1.86-10.85-20.84-31.31-20.84-31.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m1189.07,602.08c-.07.18-4.91,11.3-17.36,13.03.35-1.29.67-2.61.95-3.92,0,0,6.83,1.38,16.41-9.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m1212.81,683.89s-.91,1.93-3.41,9.51c-2.55-21.29-1.21-32.38-1.21-32.38.28,11.38,4.63,22.87,4.63,22.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m1185.89,539.95s13.57,2.61,20.34,13.66c0,0-1.37-10-8.13-12.89-6.75-2.88-12.21-.76-12.21-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m1205.1,707.34c-.32,1.32-.6,2.49-.8,3.31-.22.9-.42,1.86-.59,2.87-8.4-4.57-14.44-8.14-14.44-8.14,2.26.51,15.84,1.97,15.84,1.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m1190.75,623.64l-23.88,19.47,2.46-20.51s13.92-3,21.42,1.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "1173.77 639.8 1166.87 643.11 1190.33 619.86 1173.77 639.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m1206.51,705.66c-3.29,13.62,8.88,44.27,8.88,44.27l-24.1,7.54c-3.47,1.08-7.12-1.04-7.88-4.6-3.23-15-10.79-51.92-11.7-72.44-1.15-26.19,17.91-57.09,17.91-57.09,33.89,5.82,24.6,57.09,24.6,57.09,0,0-1.23,3.23-2.87,8.28h0c-.42,1.27-.85,2.65-1.31,4.13-1.16,3.79-2.41,8.19-3.53,12.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m1166.93,623.72l.42-1.12s-17.35,2.64-26.18,7.04c-8.82,4.41-25.71,27.17-25.71,27.17l22.09,29.16c.02,22.41-3.61,62.25-3.61,62.25l10.1,5.82c2.71,1.56,6.11-.35,6.17-3.49.28-15.15.96-51.13,1.32-68.56.46-22.41,16.45-58.65,16.45-58.65-.36.12-.7.25-1.05.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m1135.46,728.79s16.65.65,19.24,0c2.59-.65,19.87-8.14,20.91-15.55,1.04-7.4-40.15,6.64-40.15,6.64v8.91Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "1187.13 705.66 1119.55 697.75 1150.08 722.59 1187.13 705.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "1150.08 722.59 1187.13 709.96 1187.13 705.66 1148.83 717.95 1150.08 722.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m1167.5,693.25s-5.59,0-8.72-.64c-2.42-.49-8.45.19-9.98,1.55-1.54,1.36-6.41,10.83-7.34,11.41-.92.58.47,1.92,2.09,1.25,0,0,1.49,4.14,5.16,2.59,3.67-1.55,6.16-4.94,8.09-5.53,1.92-.6,13.12-3.61,13.12-3.61,0,0,.46-8.02-2.43-7.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "1170.61 618.82 1157.74 639.19 1151.53 643.11 1166.01 622.82 1170.61 618.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "1157.74 639.19 1166.87 643.11 1169.33 622.6 1170.61 618.82 1157.74 639.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m1137.5,719.26s-.69,8.61,0,10.41c0,0-41.68-4.17-45.56-9.99-3.89-5.83-3.74-12.91-3.74-12.91l49.31,12.49Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "1150.08 722.59 1130.38 649.32 1055.44 641.41 1075.98 708.85 1150.08 722.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "1190.33 619.86 1173.77 639.8 1182.83 647.88 1192.6 624 1190.33 619.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m1211.9,687.02s-.55,1.68-.55,1.69c-.42,1.26-.85,2.65-1.31,4.12-3.2,1.01-30.88-1.03-30.88-1.03,0,0,23.17-5.43,32.74-4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m1210.3,692.29c-4.46-.33-11.76-.81-17.74-.84-9.3-.04-25.21,1-25.21,1l1.89,9.94s28.18,4.58,43.57,5.66h0s20.31,2.33,21.82-.7c1.51-3.03-.5-22.48-3.8-40.01-3.3-17.53-6.7-27.62-10.74-33.04-4.04-5.41-25.37-9.64-25.37-9.64l18.1,59.24s2.59,5.28,2.46,7.56c-.04.7-.52,1.02-1.17,1.14-.45-.04-1.46-.12-2.84-.23l-.97-.08Z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroImage);
export default __webpack_public_path__ + "static/media/hero-image.5346668f8092f0a93b42be3195beeaa7.svg";
export { ForwardRef as ReactComponent };